import { commonRoutes } from '../commonRoutes';

export const WOW_RETAIL_ROUTES = {
  ...commonRoutes,

  AdTestingVideo: '/ad-testing/video',

  TournamentGlobalCoverage: '/mythic-dungeon-international/:tournament/highlights',
  PvPTournamentGlobalCoverage: '/arena-world-championship/:tournament/highlights',
  TransmogCoverage: '/transmogs',
  GenericGlobalCoveragePage: '/coverage/:tournament/highlights',

  Blizzcon2019: '/blizzcon-2019',
  MdiSummer2019BracketsFinals: '/mythic-dungeon-international/summer-2019-brackets/blizzcon-finals',

  Dmt2019BracketsPage: '/dream-mythic-tournament/2019/:bracket',

  Ksm2020BracketsPage: '/keystone-masters/brackets/:bracket',

  // winterspring fling
  Ksm2020TimeTrialsLeaderboardPage: '/keystone-masters/time-trials/winterspring-fling-2020',
  Ksm2020TimeTrialsTeamDetailsPage: '/keystone-masters/time-trials-team/:id',
  Ksm2020TimeTrialsTeamLeaderboardPage: '/keystone-masters/time-trials-teams/winterspring-fling-2020/:page?',

  // format-experiments
  Ksm2020FXBracketsPage: '/keystone-masters/format-experiments-2020/bracket',
  Ksm2020FXTimeTrialsLeaderboardPage: '/keystone-masters/format-experiments-2020/time-trials',
  Ksm2020FXTimeTrialsTeamDetailsPage: '/keystone-masters/format-experiments-2020/time-trials-team/:id',
  Ksm2020FXTimeTrialsTeamLeaderboardPage: '/keystone-masters/format-experiments-2020/time-trials-teams/:page?',

  // bloodlust io
  BloodlustBFABracket2020: '/bloodlust-io/bfa-2020/brackets/:bracket',
  BloodlustSLBracket2021: '/bloodlust-io/sl-2021/brackets/:bracket',

  // Keystone Builders
  KeystoneBuildersSeason2TeamRankingsPage: '/keystone-builders/season-2/team-rankings/:page?',
  KeystoneBuildersSeason2TeamDetailsPage: '/keystone-builders/season-2/teams/:id',

  KeystoneBuildersSeason3FinalsTournamentMapRankings: '/keystone-builders/season-3-finals/dungeons',
  KeystoneBuildersSeason3FinalsTournamentTeamRankings: '/keystone-builders/season-3-finals/teams/:page?',
  KeystoneBuildersSeason3FinalsTournamentTeamDetails: '/keystone-builders/season-3-finals/team-details/:id',

  KeystoneBuildersSeason3TeamRankingsPage: '/keystone-builders/season-3/team-rankings/:page?',
  KeystoneBuildersSeason3TeamDetailsPage: '/keystone-builders/season-3/teams/:id',

  KeystoneBuildersSeason3Registration: '/keystone-builders/season-3/signups',
  KeystoneBuildersSeason3RegistrationSuccess: '/keystone-builders/season-3/successful-signup',

  // Ukraine Tournament Realm Event 2023
  UkraineTR2023Registration: '/ukraine-mplus-season-df-2/signups',
  UkraineTR2023RegistrationSuccess: '/ukraine-mplus-season-df-2/successful-signup',

  // Dungeon Dojo Invitational
  DungeonDojoSeason1TeamRankingsPage: '/dungeon-dojo-invitational/season-1/team-rankings/:page?',
  DungeonDojoSeason1TeamDetailsPage: '/dungeon-dojo-invitational/season-1/teams/:id',

  // mythic plus charity pro-am 2021
  CharityProAm2021: '/charity-pro-am/brackets/:bracket',

  // mythic plus charity pro-am 2022
  CharityProAm2022TournamentMapRankings: '/charity-pro-am-2022/dungeons',
  CharityProAm2022TournamentTeamRankings: '/charity-pro-am-2022/teams/:page?',
  CharityProAm2022TournamentTeamDetails: '/charity-pro-am-2022/team-details/:id',

  // mythic plus charity pro-am 2022
  CharityProAm2023TournamentMapRankings: '/charity-pro-am-2023/dungeons',
  CharityProAm2023TournamentTeamRankings: '/charity-pro-am-2023/teams/:page?',
  CharityProAm2023TournamentTeamDetails: '/charity-pro-am-2023/team-details/:id',

  // eve ascension 2023
  EveAscension2023TournamentMapRankings: '/eve-ascension-2023/dungeons',
  EveAscension2023TournamentTeamRankings: '/eve-ascension-2023/teams/:page?',
  EveAscension2023TournamentTeamDetails: '/eve-ascension-2023/team-details/:id',

  // eve ascension df season 2
  EveAscensionDFSeason2Registration: '/eve-ascension-df-season-2/signups',
  EveAscensionDFSeason2RegistrationSuccess: '/eve-ascension-df-season-2/successful-signup',
  EveAscensionDFSeason2QualifiersMapRankings:
    '/mythic-plus-rankings/season-df-2-event-eve-ascension/all/world/leaderboards',
  EveAscensionDFSeason2QualifiersTeamRankings: '/eve-ascension-df-season-2/teams/:page?',

  // eve ascension df season 2 finals
  EveAscensionDfS2TournamentTeamDetails: '/eve-ascension-df-season-2/team-details/:id',
  EveAscensionDfS2TournamentMapRankings: '/eve-ascension-df-season-2/maps/:bracket',
  EveAscensionDfS2TournamentTeamRankings: '/eve-ascension-df-season-2/teams/:bracket/:page?',

  // dream gaming
  DreamGaming2020BracketsPage: '/dream-mythic-masters/brackets/:bracket',
  DreamGaming2020TimeTrialsLeaderboardPage: '/dream-mythic-masters/time-trials/:leaderboard',
  DreamGaming2020TimeTrialsTeamDetailsPage: '/dream-mythic-masters/time-trials-team/:id',
  DreamGaming2020TimeTrialsTeamLeaderboardPage: '/dream-mythic-masters/time-trials-teams/:leaderboard/:page?',

  KeystoneCharacterRankings: '/mythic-plus-character-rankings/:season/:region/:class/:role/:page?',
  KeystoneCharacterRealmRankings: '/mythic-plus-character-realm-rankings/:season/:region/:realm/:class/:role/:page?',
  KeystoneCharacterFactionRankings:
    '/mythic-plus-character-faction-rankings/:season/:region/:class/:role/:faction/:page?',
  KeystoneCharacterFactionRealmRankings:
    '/mythic-plus-character-realm-faction-rankings/:season/:region/:realm/:class/:role/:faction/:page?',

  KeystoneWarbandRankings: '/mythic-plus-warband-rankings/:season/:region/:role/:page?',

  KeystoneTeamRankings: '/mythic-plus-group-rankings/:season/:region/:page?',
  KeystoneTeamDetails: '/mythic-plus-groups/:id',

  KeystoneRunRankings: '/mythic-plus-rankings/:season/:dungeon/:region/:type/:page?',
  KeystoneRunAffixRankings: '/mythic-plus-affix-rankings/:season/:dungeon/:region/:type/:affixes/:page?',
  KeystoneRunFactionRankings: '/mythic-plus-faction-rankings/:season/:dungeon/:region/:type/:faction/:page?',
  KeystoneRunFactionAffixRankings:
    '/mythic-plus-faction-affix-rankings/:faction/:season/:dungeon/:region/:type/:affixes/:page?',

  KeystoneSpecRankings: '/mythic-plus-spec-rankings/:season/:region/:class/:spec/:page?',
  KeystoneSpecRealmRankings: '/mythic-plus-spec-realm-rankings/:season/:region/:realm/:class/:spec/:page?',
  KeystoneSpecFactionRankings: '/mythic-plus-spec-faction-rankings/:season/:region/:class/:spec/:faction/:page?',
  KeystoneSpecFactionRealmRankings:
    '/mythic-plus-spec-realm-faction-rankings/:season/:region/:realm/:class/:spec/:faction/:page?',

  CollegiateDungeonRaceLanding: '/tespa-collegiate-dungeon-race-2017',
  CollegiateDungeonRaceOverview: '/tespa-collegiate-dungeon-race-2017/:bracket',

  NewsList: '/news',
  NewsArticle: '/news/:id',
  WeeklyRoutes: '/weekly-routes',
  PlayLikeThePros: '/play-like-the-pros',

  TeamLeaderboardPage: '/team-rankings/:season/:region/:bracket/:week/:faction/:page?',
  TeamLeaderboardEventPage: '/team-rankings/:season/:region/:event/:page?',
  TeamRoster: '/teams/:region/:team/roster',
  TeamRecruitment: '/teams/:region/:team/recruitment',
  TeamCharacterKeystoneLeaderboard: '/teams/:region/:team/mythic-plus-characters/:season',
  TeamStats: '/teams/:region/:team/stats/:type?',

  MythicKeystoneRun: '/mythic-plus-runs/:season/:id',
  MythicPlusRealms: '/mythic-plus/realms/:region/:scope',
  MythicPlusCutoffs: '/mythic-plus/cutoffs/:season/:region',

  LiveLoggedRunList: '/live/mythic-plus-runs/:season/:filter/:page?',

  KeystoneEventClientUsage: '/keystone-event/:event_id/client-usage/:token?',

  // replays
  ReplaysSettings: '/settings/replays',

  Search: '/search',

  CharacterSnapshot: '/embed/characters/:mode/:id/:timestamp',
  GuildSnapshot: '/embed/guilds/:mode/:id/:timestamp',
  EmbedEventBracket: '/embed/events/:slug/brackets/:bracketSlug',

  LudicrousSpeed: '/ludicrous-speed',
  IOScore: '/io-score',
  RaidlePage: '/raidle',

  YearInReview2017: '/year-in-review-2017',
  YearInReview2018: '/year-in-review-2018',
  MyBFAInReviewCreator: '/bfa-review',
  MyBFAInReviewInstance: '/bfa-review/:id',

  MySL1InReviewCreator: '/sl1-review',
  MySL1InReviewInstance: '/sl1-review/:id',

  MySL2InReviewCreator: '/sl2-review',
  MySL2InReviewInstance: '/sl2-review/:id',

  CharityProAm2022Registration: '/charity-pro-am-2022/signups',
  CharityProAm2022RegistrationSuccess: '/charity-pro-am-2022/successful-signup',

  CharityProAm2023Registration: '/charity-pro-am-2023/signups',
  CharityProAm2023RegistrationSuccess: '/charity-pro-am-2023/successful-signup',

  GiveawayDragonflightBetaKeys2022Entry: '/giveaways/dragonflight-beta-keys',
  GiveawayDragonflightBetaKeys2022EntrySuccess: '/giveaways/dragonflight-beta-keys/success',

  BreakTheMeta2022SignupPage: '/break-the-meta-2022/signups',
  BreakTheMeta2023SignupPage: '/break-the-meta-2023/signups',
  BreakTheMetaDfSeason2SignupPage: '/break-the-meta-df-season-2/signups',

  MySL3InReviewCreator: '/sl3-review',
  MySL3InReviewInstance: '/sl3-review/:id',

  MySLInReviewCreator: '/shadowlands-review',
  MySLInReviewInstance: '/shadowlands-review/:id',

  MyDF1InReviewCreator: '/dragonflight-season-1-recap',
  MyDF1InReviewInstance: '/dragonflight-season-1-recap/:id',

  MyDF2InReviewCreator: '/dragonflight-season-2-recap',
  MyDF2InReviewInstance: '/dragonflight-season-2-recap/:id',

  MyDF3InReviewCreator: '/dragonflight-season-3-recap',
  MyDF3InReviewInstance: '/dragonflight-season-3-recap/:id',

  MyDFInReviewCreator: '/dragonflight-review',
  MyDFInReviewInstance: '/dragonflight-review/:id',

  MyTWW1InReviewCreator: '/the-war-within-season-1-recap',
  MyTWW1InReviewInstance: '/the-war-within-season-1-recap/:id',

  MyTWW2InReviewCreator: '/the-war-within-season-2-recap',
  MyTWW2InReviewInstance: '/the-war-within-season-2-recap/:id',

  MyTWWInReviewCreator: '/tww-review',
  MyTWWInReviewInstance: '/tww-review/:id',

  StreamGreatPushSingleDungeonsWidget: '/widgets/dungeons',
  StreamGreatPushLeaderboardWidget: '/widgets/team-dungeons-leaderboard',

  KeystoneTeamRankingsMdi2017: '/mythic-dungeon-invitational/:region/:page?',
  KeystoneTeamDetailsMdi2017: '/mythic-plus-teams/:id',
  MythicDungeonInvitational2017Landing: '/mythic-dungeon-invitational',
  MythicDungeonInvitational2017Overview: '/mythic-dungeon-invitational-regionals/:region',

  // MDI 2018
  MythicDungeonInvitational2018Overview: '/mythic-dungeon-invitational-2018/brackets/:bracket',
  MythicDungeonInvitational2018TimeTrialsPreparation: '/mythic-dungeon-invitational-2018/time-trials-preparation',
  MythicDungeonInvitational2018TimeTrialsOverview: '/mythic-dungeon-invitational-2018/time-trials/:region',
  MythicDungeonInvitational2018StandingsPage: '/mythic-dungeon-invitational-2018/standings',
  KeystoneTeamDetailsMdi2018: '/mythic-dungeon-invitational-2018/teams/:id',
  MythicDungeonInvitational2018ProvingGrounds: '/mythic-dungeon-invitational-2018/proving-grounds',
  KeystoneTeamRankingsMdi2018: '/mythic-dungeon-invitational-2018/proving-grounds/:region/:page?',
  KeystoneTimeTrialsTeamDetailsMdi2018: '/mythic-dungeon-invitational-2018/time-trials-team/:id',
  KeystoneTimeTrialsTeamRankingsMdi2018: '/mythic-dungeon-invitational-2018/time-trials-teams/:region/:page?',
  MythicDungeonInvitational2018RegionalLanding: '/mythic-dungeon-invitational-2018/regional-group-stage',
  MythicDungeonInvitational2018GlobalLanding: '/mythic-dungeon-invitational-2018/global-group-stage',

  // MDI 2018 All Stars
  MythicDungeonInvitational2018AllStarsOverview: '/mythic-dungeon-invitational-allstars-2018/bracket',
  MythicDungeonInvitational2018AllStarsLanding: '/mythic-dungeon-invitational-allstars-2018/overview',

  // MDI Spring 2019
  MythicDungeonInvitationalSpring2019ProvingGrounds: '/mythic-dungeon-international/spring-2019-proving-grounds',
  MythicDungeonInvitationalSpring2019Overview: '/mythic-dungeon-international/spring-2019-brackets/:bracket',
  KeystoneTeamRankingsMdiSpring2019: '/mythic-dungeon-international/spring-2019-proving-grounds/:region/:page?',
  KeystoneTeamDetailsMdiSpring2019: '/mythic-dungeon-international/spring-2019-teams/:id',
  KeystoneTimeTrialsTeamDetailsMdiSpring2019: '/mythic-dungeon-international/spring-2019-time-trials-team/:id',
  KeystoneTimeTrialsTeamRankingsMdiSpring2019:
    '/mythic-dungeon-international/spring-2019-time-trials-teams/:division/:region/:page?',
  MythicDungeonInvitationalSpring2019TimeTrialsOverview: '/mythic-dungeon-international/spring-2019-time-trials/:trial',
  MythicDungeonInvitationalSpring2019FinalsOverview: '/mythic-dungeon-international/spring-2019-finals',
  MythicDungeonInvitationalSpring2019Standings: '/mythic-dungeon-international/spring-2019-standings',

  // MDI Summer 2019
  MythicDungeonInvitationalSummer2019Overview: '/mythic-dungeon-international/summer-2019-brackets/:bracket',
  KeystoneTeamRankingsMdiSummer2019: '/mythic-dungeon-international/summer-2019-proving-grounds/:region/:page?',
  KeystoneTeamDetailsMdiSummer2019: '/mythic-dungeon-international/summer-2019-teams/:id',
  KeystoneTimeTrialsTeamDetailsMdiSummer2019: '/mythic-dungeon-international/summer-2019-time-trials-team/:id',
  KeystoneTimeTrialsTeamRankingsMdiSummer2019:
    '/mythic-dungeon-international/summer-2019-time-trials-teams/:division/:region/:page?',
  MythicDungeonInvitationalSummer2019TimeTrialsOverview: '/mythic-dungeon-international/summer-2019-time-trials/:trial',
  MythicDungeonInvitational2019SummerFinalsOverview: '/blizzcon-2019',
  MythicDungeonStandingsSummer2019Standings: '/mythic-dungeon-international/summer-2019-standings',

  // MDI Summer 2020
  MythicDungeonInternationalStandingsBfa2020: '/mythic-dungeon-international/bfa-season-4-standings',
  MythicDungeonInternationalBracketBfa2020: '/mythic-dungeon-international/bfa-season-4-brackets/:bracket',
  MythicDungeonInternationalTimeTrialsTeamDetailsBfa2020:
    '/mythic-dungeon-international/bfa-season-4-time-trials-team/:id',
  MythicDungeonInternationalTimeTrialsTeamRankingsBfa2020:
    '/mythic-dungeon-international/bfa-season-4-time-trials-teams/:division/:region/:page?',
  MythicDungeonInternationalTimeTrialsOverviewBfa2020: '/mythic-dungeon-international/bfa-season-4-time-trials/:trial',

  // MDI Shadowlands Season 1
  MythicDungeonInternationalStandingsSLSeason1: '/mythic-dungeon-international/sl-season-1-standings',
  MythicDungeonInternationalBracketSLSeason1: '/mythic-dungeon-international/sl-season-1-brackets/:bracket',
  MythicDungeonInternationalTimeTrialsTeamDetailsSLSeason1:
    '/mythic-dungeon-international/sl-season-1-time-trials-team/:id',
  MythicDungeonInternationalTimeTrialsTeamRankingsSLSeason1:
    '/mythic-dungeon-international/sl-season-1-time-trials-teams/:division/:region/:page?',
  MythicDungeonInternationalTimeTrialsOverviewSLSeason1: '/mythic-dungeon-international/sl-season-1-time-trials/:trial',

  // MDI Shadowlands Season 2
  MythicDungeonInternationalBracketSLSeason2: '/mythic-dungeon-international/sl-season-2-brackets/:bracket',
  MythicDungeonInternationalTimeTrialsTeamDetailsSLSeason2:
    '/mythic-dungeon-international/sl-season-2-time-trials-team/:id',
  MythicDungeonInternationalTimeTrialsTeamRankingsSLSeason2:
    '/mythic-dungeon-international/sl-season-2-time-trials-teams/:trial/:page?',
  MythicDungeonInternationalTimeTrialsOverviewSLSeason2: '/mythic-dungeon-international/sl-season-2-time-trials/:trial',

  // MDI Shadowlands Season 3
  MythicDungeonInternationalBracketSLSeason3: '/mythic-dungeon-international/sl-season-3-brackets/:bracket',
  MythicDungeonInternationalTimeTrialsTeamDetailsSLSeason3:
    '/mythic-dungeon-international/sl-season-3-time-trials-team/:id',
  MythicDungeonInternationalTimeTrialsTeamRankingsSLSeason3:
    '/mythic-dungeon-international/sl-season-3-time-trials-teams/:trial/:page?',
  MythicDungeonInternationalTimeTrialsOverviewSLSeason3: '/mythic-dungeon-international/sl-season-3-time-trials/:trial',

  // MDI Dragonflight Season 1
  MythicDungeonInternationalBracketDFSeason1: '/mythic-dungeon-international/df-season-1-brackets/:bracket',
  MythicDungeonInternationalTimeTrialsTeamDetailsDFSeason1:
    '/mythic-dungeon-international/df-season-1-time-trials-team/:id',
  MythicDungeonInternationalTimeTrialsTeamRankingsDFSeason1:
    '/mythic-dungeon-international/df-season-1-time-trials-teams/:trial/:page?',
  MythicDungeonInternationalTimeTrialsOverviewDFSeason1: '/mythic-dungeon-international/df-season-1-time-trials/:trial',

  // Blizzcon Guild Clash 2023
  BlizzconGuildClash2023: '/blizzcon-guild-clash-2023/:bracket',

  // MDI Dragonflight Season 2: The Great Push
  MythicDungeonInternationalGreatPushDFSeason2QualifiersMapRankings:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2/proving-grounds-dungeons',
  MythicDungeonInternationalGreatPushDFSeason2QualifiersTeamRankings:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2/proving-grounds-teams/:page?',
  MythicDungeonInternationalGreatPushDFSeason2BlizzQualifiersMapRankings:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2/blizzard-proving-grounds-dungeons',
  MythicDungeonInternationalGreatPushDFSeason2BlizzQualifiersTeamRankings:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2/blizzard-proving-grounds-teams/:page?',
  MythicDungeonInternationalGreatPushDFSeason2TeamDetails:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2-teams/:id',
  MythicDungeonInternationalGreatPushDFSeason2TournamentMapRankings:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2/tournament-dungeons/:bracket',
  MythicDungeonInternationalGreatPushDFSeason2TournamentTeamRankings:
    '/mythic-dungeon-international/the-great-push-dragonflight-season-2/tournament-teams/:bracket/:page?',

  UKraineMPlusDFSeason2: '/ukraine-mplus/df-season-2/brackets/:bracket',

  // MDI Shadowlands Season 1: The Great Push
  MythicDungeonInternationalGreatPushQualifiersMapRankings:
    '/mythic-dungeon-international/the-great-push/proving-grounds-dungeons',
  MythicDungeonInternationalGreatPushQualifiersTeamRankings:
    '/mythic-dungeon-international/the-great-push/proving-grounds/:page?',
  MythicDungeonInternationalGreatPushQualifiersTeamDetails:
    '/mythic-dungeon-international/the-great-push-proving-grounds-teams/:id',
  MythicDungeonInternationalGreatPushTournamentMapRankings:
    '/mythic-dungeon-international/the-great-push/tournament-dungeons',
  MythicDungeonInternationalGreatPushTournamentTeamRankings:
    '/mythic-dungeon-international/the-great-push/tournament/:page?',
  MythicDungeonInternationalGreatPushTournamentTeamDetails:
    '/mythic-dungeon-international/the-great-push-tournament-teams/:id',

  // MDI Shadowlands Season 2: The Great Push
  MythicDungeonInternationalGreatPushSeason2QualifiersMapRankings:
    '/mythic-dungeon-international/the-great-push-season-2/proving-grounds-dungeons',
  MythicDungeonInternationalGreatPushSeason2QualifiersTeamRankings:
    '/mythic-dungeon-international/the-great-push-season-2/proving-grounds/:page?',
  MythicDungeonInternationalGreatPushSeason2QualifiersTeamDetails:
    '/mythic-dungeon-international/the-great-push-season-2-proving-grounds-teams/:id',
  MythicDungeonInternationalGreatPushSeason2TournamentMapRankings:
    '/mythic-dungeon-international/the-great-push-season-2/tournament-dungeons',
  MythicDungeonInternationalGreatPushSeason2TournamentTeamRankings:
    '/mythic-dungeon-international/the-great-push-season-2/tournament/:page?',
  MythicDungeonInternationalGreatPushSeason2TournamentTeamDetails:
    '/mythic-dungeon-international/the-great-push-season-2-tournament-teams/:id',

  // MDI Shadowlands Season 4: The Great Push
  MythicDungeonInternationalGreatPushSeason4QualifiersMapRankings:
    '/mythic-dungeon-international/the-great-push-shadowlands-season-4/proving-grounds-dungeons/:bracket',
  MythicDungeonInternationalGreatPushSeason4QualifiersTeamRankings:
    '/mythic-dungeon-international/the-great-push-shadowlands-season-4/proving-grounds-teams/:bracket/:page?',
  MythicDungeonInternationalGreatPushSeason4TournamentMapRankings:
    '/mythic-dungeon-international/the-great-push-shadowlands-season-4/tournament-dungeons/:bracket',
  MythicDungeonInternationalGreatPushSeason4TournamentTeamRankings:
    '/mythic-dungeon-international/the-great-push-shadowlands-season-4/tournament-teams/:bracket/:page?',
  MythicDungeonInternationalGreatPushSeason4TeamDetails:
    '/mythic-dungeon-international/the-great-push-shadowlands-season-4-teams/:id',

  // AFDC 2022
  AFDC2022TournamentMapRankings: '/afdc/season-sl-3/tournament-dungeons',
  AFDC2022TournamentTeamRankings: '/afdc/season-sl-3/tournament-teams/:page?',
  AFDC2022TournamentTeamDetails: '/afdc/season-sl-3/team-details/:id',

  // AFDC 2022 Season 4
  AFDC2022Season4TournamentMapRankings: '/afdc/season-sl-4/tournament-dungeons',
  AFDC2022Season4TournamentTeamRankings: '/afdc/season-sl-4/tournament-teams/:page?',
  AFDC2022Season4TournamentTeamDetails: '/afdc/season-sl-4/team-details/:id',

  // File Manager
  FileManager: '/admin/file-manager',

  UserStats: '/user/:name/stats/:type?',

  // Timeline Manager
  TimelineEventManagement: '/admin/timeline-manager',
  TimelineEventManagementCreate: '/admin/timeline-manager/create',
  TimelineEventManagementDetails: '/admin/timeline-manager/:id',

  // Site Moderation
  SiteModeration: '/admin/site-moderation',
  SiteModerationBans: '/admin/site-moderation/bans',
  SiteModerationReport: '/admin/site-moderation/:referenceCode',

  // User Applications
  CreateUserApplication: '/settings/apps/create',
  UserApplication: '/settings/apps/:appId',
  UserApplications: '/settings/apps',

  // Guild Monitoring
  GuildBossProgressMonitoringTool: '/raiding/guild-monitor',
  LiveLoggedEncounterList: '/live/raid-encounters',
  AllRaidsHallOfFame: '/raiding/hall-of-fame',

  BattleNetRedirect: '/battlenet-auth-redirect',

  SpecsIndex: '/specs',

  SpecTalentCompare: '/specs/compare',
  SpecStatistics: '/specs/:specSlug/:type',

  GroupCompositionCompare: '/raiding/compare-raid-comps'
};

export type TWowRetailRoutes = typeof WOW_RETAIL_ROUTES;
